import { render, staticRenderFns } from "./RecipeInstruction.vue?vue&type=template&id=c7dd0066&scoped=true"
import script from "./RecipeInstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeInstruction.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeInstruction.vue?vue&type=style&index=0&id=c7dd0066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dd0066",
  null
  
)

export default component.exports